<template>
    <section class="flex font-poppins md:flex-col">
         <div >
                <AdminDashboardNav/>
        </div> 
        <div class="w-screen  p-2" >
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-2">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MESSAGES</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            <section class="mt-10">
                <div class="flex">
                    <div class="flex cursor-pointer" @click="goBack">
                        <i class="fa fa-arrow-left"></i>
                        <p class="ml-3">Go Back</p>
                    </div>
                    <p class="ml-4">Admin Email Center</p>
                </div>
                <div class="mt-6">
                    <SendEmail :id="id"/>
                </div>
            </section>
        </div>

    </section>
</template>

<script>
import AdminDashboardNav from "../../AdminDashboardNav.vue";
import GetDate from "../../GetDate.vue";
import Notification from "../../Notification.vue";
import SendEmail from "./SendEmail.vue";
export default {
    props: ["id"],
    components: {
        AdminDashboardNav,
        GetDate,
        Notification,
        SendEmail
    },

    methods: {
        goBack() {
           this.$router.go(-1)
        },
    }
}
</script>